import React from 'react';
import { BsFormControl, BsModalForm, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';
import { useLoad } from '../../collection/Hooks';
import Loading from '../../collection/icons/Loading';

export default function DiasLibresModal(props) {
    const isNew = props.id < 1;

    const updateData = async () => await apiGet("diasLibres/get/" + props.id);

    const checkData = formData => {
        let errors = {};
        // Trabajador
        const trabajador = formData.get("trabajador");
        if (!trabajador) {
            errors["trabajador"] = "Campo obligatorio";
        }
        // Dia
        const dia = formData.get("dia");
        if (!dia) {
            errors["dia"] = "Campo obligatorio";
        }
        // Comentario
        const comentario = formData.get("comentario");
        if (!comentario) {
            errors["comentario"] = "Campo obligatorio";
        }

        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("diasLibres/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nuevo día libre" : "Editar día libre"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <DiasLibresForm />
        </BsModalForm>
    );
}

function DiasLibresForm(props) {
    const data = props.data;
    const errors = props.errors;
    const [userList, reload] = useLoad(async () => { return await apiGet(`usuarios/list${props.super ? "" : "trabajadores"}`) });

    return userList ? <>
        <BsFormControl
            /* Día */
            label="Día" name="dia"
            value={data.dia} error={errors.dia}
            type="date" />
        <BsFormSelect
            /* Trabajador */
            label="Trabajador" name="trabajador"
            value={data.trabajador} error={errors.trabajador}
            options={userList}
            className="mt-3" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
    </> : <Loading />;
}
